export default {
  "hero": {
    "watch_video": "Assista nosso vídeo",
    "image_src": "/images/hero/q-alem-da-qualidade.png"
  }
}
